// custom-slider.js or within theme.js

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.image-comparison');
  
  sliders.forEach(slider => {
    const afterImage = slider.querySelector('.after-image');
    const handle = slider.querySelector('.slider-handle');
    
    let isDragging = false;
    
    function handleMove(event) {
      if (!isDragging) return;
      
      const rect = slider.getBoundingClientRect();
      let xPos = (event.clientX || event.touches[0].clientX) - rect.left;
      xPos = Math.max(0, Math.min(xPos, rect.width));
      
      const widthPercentage = (xPos / rect.width) * 100;
      
      afterImage.style.clipPath = `inset(0 ${100 - widthPercentage}% 0 0)`;
      handle.style.left = `${widthPercentage}%`;
    }
    
    handle.addEventListener('mousedown', () => isDragging = true);
    document.addEventListener('mouseup', () => isDragging = false);
    document.addEventListener('mousemove', handleMove);

    // For mobile support
    handle.addEventListener('touchstart', () => isDragging = true);
    document.addEventListener('touchend', () => isDragging = false);
    document.addEventListener('touchmove', handleMove);
  });
});
